// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

/*** Adding toggle class */
/*const btnwrapper = document.querySelector(".btn-ver-imagen");
const classes = btnwrapper.classList;
btnwrapper.addEventListener("click", () => {
  const result = classes.toggle("d-none");
});*/


const btnWrapper = document.querySelector(".btn-ver-imagen");

if (btnWrapper) {
  btnWrapper.addEventListener("click", () => {
    btnWrapper.classList.toggle("d-none");
  });
}